import { UserProfileType } from '@app/finxone-web-frontend/app/lib/services/keycloak-wrapper-service/keycloak-custom.type';

export class MockKeycloakCustomService {
  constructor() {}

  public async getUserOrganisationList(id: string): Promise<UserProfileType[]> {
    return [
      {
        id: 'b5558138-7f3a-4a29-864d-634987486a77',
        name: 'Google',
        displayName: 'Google',
        realm: 'customer1',
        domains: [],
        attributes: {},
      },
      {
        id: 'ac2feff5-9aa1-444f-8147-5e94630ef239',
        name: 'Tesla',
        displayName: 'Tesla',
        realm: 'customer1',
        domains: [],
        attributes: {},
      },
      {
        id: 'ac2feff5-9aa1-444f-8147-5e94630ef237',
        name: 'Organisation Pvt. Ltd.',
        displayName: 'Organisation Pvt. Ltd.',
        realm: 'customer1',
        domains: [],
        attributes: {},
      },
      {
        id: 'ac2feff5-9aa1-444f-8147-5e94630ef235',
        name: 'Organisation',
        displayName: 'Organisation',
        realm: 'customer1',
        domains: [],
        attributes: {},
      },
    ];
  }
}
